










    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { Component,Vue,Watch } from 'vue-property-decorator'
    import { State,  Getter, Action,Mutation, namespace } from 'vuex-class'
    const site = namespace('site')
    @Component({
        components:{
            Treeselect
        }
    })
    export default class SiteList extends Vue{
        @site.State('mapList') mapList:any //网点列表
        @site.State('mapcenter') mapcenter:any //网点列表
        @Getter('siteOrg') siteOrg:any //组织架构
        zoom = 10
        search:any = {
            site_org: null, //组织架构
        }
        windowInfo = {
			position: [104.07, 30.67],
			content: '111',
			visible: false
		}
        get list(){
            const _this = this
            return this.mapList.map((item:any) => {
                    item.events = {
                        click(e:any) {
                            console.log(_this.windowInfo);
                            _this.windowInfo.visible = false
                            _this.$nextTick(() => {
                                _this.windowInfo = {
                                    position: item.location,
                                    content: `<div style="display:flex"> <img src="${item.images[0]}" style="height: 50px;margin-right:10px" /><div> <p>网点名：${item.name}</p><p>地址：${item.address}</p> </div> </div>`,
                                    visible: true
                                }
                            });
                        }
                    }
                    return item
                })
        }
        @site.Action('getMapSiteList') getMapSiteList:any
        async created(){
            await this.getList()
        }
        async getList(){
            await this.getMapSiteList(this.search)
        }
        // 配置树形图的参数
        normalizer(node:any) {
            let data = {}
            this.siteOrg.forEach((item:any) => {
                data = {
                    id: node["_id"],
                    label: node["name"],
                    children: node.children,
                }
            });
            return data
            
        }
        async siteChange(e:any){
            this.search.site_org = e._id
            await this.getList()
            this.windowInfo.visible = false
        }
        switchImg(url:string){
            return `<img src="${url}" style="width: 25px" />`
        }
    }
